import { Button, Flex, Pool, Text, useModal } from '@pancakeswap/uikit'
import { useAccount } from 'wagmi'
import { useTranslation } from '@pancakeswap/localization'
import { useVaultPoolByKey } from 'state/pools/hooks'
import { DeserializedLockedVaultUser, IsCakeVault } from 'state/types'
import { Token } from '@pancakeswap/sdk'
import { getCakeVaultProfit } from 'views/Pools/helpers'
import RecentCakeProfitBalance from './RecentCakeProfitBalance'
import { HarvestModalContainer } from '../Modals/HarvestModal'

const RecentCakeProfitCountdownRow = ({ pool }: { pool: Pool.DeserializedPool<Token> }) => {
  const { t } = useTranslation()
  const { address: account } = useAccount()
  const { userData } = useVaultPoolByKey(pool.vaultKey)
  const isCakeVault = IsCakeVault(pool.vaultKey)
  const { hasAutoEarnings, autoCakeToDisplay, autoUsdToDisplay } = getCakeVaultProfit(
    account,
    userData.pendingProfit,
    pool.earningTokenPrice,
    isCakeVault
      ? (userData as DeserializedLockedVaultUser).currentPerformanceFee?.plus(
          (userData as DeserializedLockedVaultUser).currentOverdueFee,
        )
      : null,
  )

  const [onPresentCollect] = useModal(
    <HarvestModalContainer
      vaultKey={pool.vaultKey}
      formattedBalance={autoCakeToDisplay.toFixed(5)}
      fullBalance={autoCakeToDisplay.toFixed(5)}
      earningTokenSymbol="BBC"
      earningsDollarValue={autoUsdToDisplay}
    />, false, false, "modalHarvestInline"
  )

  if (!(userData.userShares.gt(0) && account)) {
    return null
  }

  return (
    <>
      <Flex alignItems="center" justifyContent="space-between">
        <Text color="textSubtle" textTransform="uppercase" bold fontSize="12px">{`${t('Recent BBC profit')}:`}</Text>
        {hasAutoEarnings && <RecentCakeProfitBalance cakeToDisplay={autoCakeToDisplay} pool={pool} account={account} />}
      </Flex>
      { !isCakeVault && hasAutoEarnings && <Button variant="secondary" width="100%" marginTop="0.5em" onClick={onPresentCollect}>Harvest</Button> }
    </>
  )
}

export default RecentCakeProfitCountdownRow
